import React from "react";

const Card = (props) => {
  // console.log(props);
  //   console.log(props.data, props.weekday);
  let description = props.data.weather[0].description;
  let icon = props.data.weather[0].icon;
  let tempLowF = (((props.data.temp.min - 273.15) * 9) / 5 + 32).toFixed(0);
  let tempHighF = (((props.data.temp.max - 273.15) * 9) / 5 + 32).toFixed(0);
  let tempLowC = (props.data.temp.min - 273.15).toFixed(0);
  let tempHighC = (props.data.temp.max - 273.15).toFixed(0);
  return (
    <div className="temp-card">
      <h3>{props.weekday}</h3>
      <img src={`http://openweathermap.org/img/w/${icon}.png`} alt="weather" />
      <p>{description}</p>
      <p>
        <b>Min:</b> {tempLowF}&#730;F &lt;&gt; {tempLowC}&#730;C
      </p>
      <p>
        <b>Max:</b> {tempHighF}&#730;F &lt;&gt; {tempHighC}&#730;C
      </p>
    </div>
  );
};

export default Card;
